import CheckboxOption from "csi/middleware/customView/options/CheckboxOption";
import { isDefined } from "csi/utility/coreUtility";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent, SyntheticEvent } from "react";

export interface DisplayCommentLinesProps {
	/** callback to handle when display comment lines attribute has been updated */
	onChange?: (event: SyntheticEvent, value: boolean) => void;

	/** the value of display comment lines attribute */
	value?: boolean | undefined;
}

const DisplayCommentLines: FunctionComponent<DisplayCommentLinesProps> = observer(function DisplayCommentLines(props) {
	const { 
		onChange,
		value,
	} = props;

	return (
		<>
			{isDefined(value) && (
				<CheckboxOption
					dataCsiAutomation="CustomViewDisplayCommentLines"
					label="CustomViewDisplayCommentLines"
					onChange={onChange}
					optionValue={value}
					paddingLeft={0}
				/>
			)}
		</>
	);
});

export default DisplayCommentLines;